import { render, staticRenderFns } from "./property-rooms-view.vue?vue&type=template&id=4d996d52"
import script from "./property-rooms-view.vue?vue&type=script&lang=js"
export * from "./property-rooms-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports